import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nullIfZero',
  standalone: true
})
export class NullIfZeroPipe implements PipeTransform {
  transform(value: number): number | null | undefined {
    return value ? value : null;
  }
}
